import React from 'react';

/**
 * UGC Layout Component
 * Provides consistent styling and theme across all UGC pages
 * Features the beautiful amber/orange gradient background with decorative elements
 */
const UGCLayout = ({ 
  children, 
  showSidebar = false,
  className = '',
  fullHeight = true 
}) => {
  return (
    <div className={`min-h-${fullHeight ? 'screen' : 'auto'} bg-gradient-to-br from-slate-950 via-slate-900 to-amber-900 relative ${className}`}>
      {/* Background decorative elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-amber-500/10 rounded-full blur-3xl"></div>
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-orange-500/10 rounded-full blur-3xl"></div>
      </div>

      {/* Content */}
      <div className="relative z-10">
        {children}
      </div>
    </div>
  );
};

export default UGCLayout;
